import { Directive, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

/**
 * Handles internal link clicks like routerlinks in dynamically injected content.
 */
@Directive({
  selector: '[boelsDynamicContentLinkHandler]',
  standalone: true,
})
export class DynamicContentLinkHandlerDirective {
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);

  @HostListener('click', ['$event'])
  click(event: MouseEvent): void {
    const tag = event.target as HTMLAnchorElement;
    if (
      tag &&
      tag.tagName === 'A' &&
      tag.href &&
      event.button === 0 &&
      tag.origin === this.document.location.origin
    ) {
      const href = tag.href.replace(tag.origin, '');
      if (href.charAt(1) !== '#') {
        event.preventDefault();
        event.stopPropagation();
        this.router.navigateByUrl(href);
      }
    }
  }
}
